<div class="exprx--common-block erx--body insurance--body patient-edit--transfer-in">
    <div class="eprx--block__header text-white pl-3 font-weight-bold">
        Transfer Type
    </div>
    <div 
    class="eprx--block__content pt-0 px-0 parent_transfeType" [formGroup]="eRxModelFG" 
    [ngClass]="RequestedInfo ? (IsFromProcess && (!PatientNotFound || PatientNotFound > 1) ? 'cards_height_transferIn' : 'height_236') : (IsTransferType ? 'cards_height_mark_transferIn' : 'cards_height_transferIn')">
    <div class="child_transfeType">
        <!--Mark as Transfer In-->
        <div *ngIf="IsfrmPatHis"  class="row col-11 ml-2 transfer--type-disabled"  >
            <div class="col-10">
                <input  class="transfer_type" type="radio" name="user_level" disabled  value="1"  id="rd1"/>&nbsp;&nbsp;
                <label for="rd1">Search from History</label> 
            </div>
            <div class="col-2">
                <i class="far fa-history  actions--Highlightfocus--icon" disabled  title="Patient History"></i>
            </div>
        </div>
           <div  *ngIf="IsfrmPatHis"  class="row col-11 mt-3 ml-2 transfer--type-disabled" >
            <div class="col-10 pr-0 specific_ndc" >
                <input type="radio" class="transfer_type" name="drug"  disabled />&nbsp;&nbsp;
                <label for="rd2" >Specific Drug/NDC 
                </label> 
            </div> 
            <div class="col-2">
                <i class="fa-kit fa-pills-regular" (click)="(IsfrmPatHis || IsPush) ? '' : openDrugSearchpopup('DrugIcon')" title="Specific Drug/NDC"></i> 
            </div>
        </div>
          <div *ngIf="IsfrmPatHis" class="row col-11  ml-2 mt-3 transfer--type-disabled"  >
            <div class="col-10">
                <input type="radio" class="transfer_type" name="all" disabled  value="3"  id="rd3" />&nbsp;&nbsp;
                <label for="rd3" >All</label>
            </div>
            <div class="col-2">
                <i class="fa-kit fa-file-prescription-regular" title="All"></i>
            </div>
        </div>
         <!--Pull Mechanisam-->
        <div *ngIf="!IsPush && !IsFromXfroutInfo && !IsfrmPatHis"  class="row col-11 ml-2 transfer--type-disabled"  >
            <div class="col-10">
                <input  class="transfer_type" type="radio" name="user_level" disabled  value="1" [formControlName]="'transferType'"    id="rd1"  
                (click)="IsPush ?  openDrugSearchpopup('history') : ''"/>&nbsp;&nbsp;
                <label for="rd1" (click)="IsPush ?  openDrugSearchpopup('history') : ''">Search from History</label> 
            </div>
            <div class="col-2">
                <i class="far fa-history  actions--Highlightfocus--icon"  (click)="IsPush ?  openDrugSearchpopup('history') : ''" title="Patient History"></i>
            </div>
        </div>
        <div *ngIf="!IsPush && !IsFromXfroutInfo && !IsfrmPatHis" class="row col-11  ml-2 mt-3" 
        [ngClass]="(RequestedInfo && DefaultTransferType == 2) ? 'transfer--type-active-disabled' : 
        ((RequestedInfo || IsfrmPatHis || IsPush) ? ((CurrentDetails && !CurrentDetails?.DrugFound && this.eRxModelFG.value['transferType'] == 2 && IsFromProcess) ? 'transfer--type-disabled' : 'transfer--type-disabled') : ((DefaultTransferType == 2 || this.eRxModelFG.value['transferType'] == 2)? 'transfer--type-active-selected' : 'transfer--type-active'))"
        [ngbTooltip]="(RequestedInfo && DefaultTransferType == 2 && !IsFromProcess) ? DrugToolTipCont : ''" triggers="mouseover:mouseleave" triggers="mouseover:mouseleave"
        [autoClose]="true" placement="top" tooltipClass="search-tooltip title-tooltip">
            <div class="col-10 pr-0 specific_ndc">
                <input type="radio" class="transfer_type" name="drug" (click)="(IsfrmPatHis || IsPush || IsFromProcess) ? '' : openDrugSearchpopup('Drug')"
                [attr.disabled]="IsfrmPatHis ? ((CurrentDetails && !CurrentDetails?.DrugFound && IsFromProcess) ? true :  (IsfrmPatHis ? true : null)) : null"  id="rd2" value="2" [formControlName]="'transferType'" />&nbsp;&nbsp;
                <label for="rd2" >Specific Drug/NDC 
                     <i (click)="(IsfrmPatHis || IsPush || IsFromProcess) ? '' : openDrugSearchpopup('Drug')" *ngIf="!RequestedInfo && eRxModelFG.value['drugID'] && (DefaultTransferType == 2 || this.eRxModelFG.value['transferType'] == 2)"  class="fas fa-info-circle erx_status"  tooltipClass="common-tooltip" [ngbTooltip]="'Choose a different drug to replace the selected drug.'"></i>
                     <i (click)="(RequestedInfo && !CurrentDetails?.DrugFound) ? '' : ''" 
                     *ngIf="IsFromProcess && !CurrentDetails?.DrugFound && RequestedInfo && (DefaultTransferType == 2 || this.eRxModelFG.value['transferType'] == 2)"  class="fas fa-info-circle erx_status"  tooltipClass="common-tooltip" 
                     [ngbTooltip]="'The requested drug is not available.'"></i>
                </label> 
            </div> 
            <div class="col-2">
                <i class="fa-kit fa-pills-regular" (click)="(IsfrmPatHis || IsPush) ? '' : ((RequestedInfo && !IsFromProcess) ? '' : (IsFromProcess ? '' : openDrugSearchpopup('DrugIcon')))" title="Specific Drug/NDC"></i> 
            </div>
        </div>
        <div *ngIf="!IsPush && !IsFromXfroutInfo && !IsfrmPatHis" class="row col-11  ml-2 mt-3" [ngClass]="(RequestedInfo && DefaultTransferType == 3) ? 'transfer--type-active-disabled' : 
        ((RequestedInfo || IsfrmPatHis || IsPush) ? 'transfer--type-disabled' : ((DefaultTransferType == 3 || this.eRxModelFG.value['transferType'] == 3) ? 'transfer--type-active-selected' : 'transfer--type-active'))"  >
            <div class="col-10">
                <input type="radio" class="transfer_type" name="all"  value="3"  id="rd3" [formControlName]="'transferType'" (click)="(IsfrmPatHis || IsFromProcess) ? '' : openDrugSearchpopup('All')" />&nbsp;&nbsp;
                <label for="rd3" (click)="(IsfrmPatHis || IsPush || IsFromProcess) ? '' : openDrugSearchpopup('All')">All</label>
            </div>
            <div class="col-2">
                <i class="fa-kit fa-file-prescription-regular" (click)="(IsfrmPatHis || IsPush || IsFromProcess) ? '' : openDrugSearchpopup('All')" title="All"></i>
            </div>
        </div>
        <!--Push Mechanisam-->
          <div  *ngIf="IsPush || IsFromXfroutInfo"  class="row col-11 ml-2" [ngClass]="IsFromXfroutInfo ? 'transfer--type-active-disabled' : 'transfer--type-active-selected'">
            <div class="col-10">
                <input  class="transfer_type" type="radio" name="user_level"   value="1"  id="transferOut"  
                (click)="IsFromXfroutInfo ? '' : openDrugSearchpopup('history')" checked/>&nbsp;&nbsp;
                <label for="transferOut" (click)="IsFromXfroutInfo ? '' : openDrugSearchpopup('history')">Search from History</label> 
            </div>
            <div class="col-2">
                <i class="far fa-history  actions--Highlightfocus--icon"  (click)="IsFromXfroutInfo ? '' : openDrugSearchpopup('history')" title="Patient History"></i>
            </div>
        </div>
        <div *ngIf="IsPush || IsFromXfroutInfo"  class="transfer--type-disabled row col-11  ml-2 mt-3" >
            <div class="col-10">
                <input type="radio" class="transfer_type" value="2"  name="drug" disabled />&nbsp;&nbsp;
                <label for="rd2">Specific Drug/NDC</label> 
            </div> 
            <div class="col-2">
                <i class="fa-kit fa-pills-regular"></i> 
            </div>
        </div>
        <div *ngIf="IsPush || IsFromXfroutInfo" class="row col-11  ml-2 mt-3 transfer--type-disabled">
            <div class="col-10">
                <input type="radio" class="transfer_type" name="all"  value="3" id="rd3" disabled />&nbsp;&nbsp;
                <label for="rd3">All</label>
            </div>
            <div class="col-2">
                <i class="fa-kit fa-file-prescription-regular"></i>
            </div>
        </div>
    </div>
    </div>

    <ng-template #DrugToolTipCont>
        <div>
            <div class="row text-left">
                <div class="col-12">
                    <label>Drug Name:  </label>
                    <span> {{RequestedInfo?.Drug?.result[0]?.drugname | uppercase}}</span>
                </div>
                <div class="col-12">
                    <label>NDC: </label>
                    <span> {{this._formatsUtil.getNDCFormat(RequestedInfo?.Drug?.result[0]?.ndc)}}</span>
                </div>
            </div>
        </div>
</ng-template>

</div>
<app-searchbox-global [SearchFor]="'Drug'" (CloseDrugResultModaIcon)="closeDrugResultModaIcon($event)" [IsDrugPopup]="true" *ngIf="isDrugSearchopen" [IsFromTransferIn]="true" (SelectedDrug)="selectedDrug($event)"></app-searchbox-global>

<ng-template #SelectRxsFromPatHistory let-c="close" let-d="dismiss" class="el--popup">
    <app-custom-modal (oncrossBtnClick)="closeModal2();transferRxInfo = []">
        <h4 header>Rx History</h4>
        <span body>
             <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding--right__7 ">
                    <div class="exprx--common-block erx--body insurance--body" *ngIf="!eRxPatient?.patientid">
                        <div class="eprx--block__header">
                            <div class="eprx--header__heading">
                                <div class="col-sm-12 padding-0">
                                    <div class="row">
                                        <div class="col-md-10">
                                            <span>Select Patient</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="eprx--block__content seconday-search--grid">
                            <app-searchbox-global  class="w-100" [SearchFor]="'Patient'" [DisableSerchFil]="true"
                                [DisableRadioButtons]="true" [IsAddNew]="false" [IsModalClass]="'max-modal-lg-size'"
                                (SelectedPatient)="selectdCancelPat($event)" class="rx-presc--search"
                                [IsFocused]="isInputFocused">
                            </app-searchbox-global>
                        </div>
                    </div>
                    <div class="exprx--common-block" *ngIf="eRxPatient?.patientid">
                        <div class="eprx--block__header">
                            <div class="eprx--header__heading">
                                Patient - {{eRxPatient?.fullname? (eRxPatient?.fullname.replace('_',', ') | uppercase):''}}
                                 <ul class="pull-right eprx--header__icons margin_right_1rem" *ngIf="!IsFromPatientHistory">
                                    <li>
                                        <a (click)="selectdCancelPat()">
                                            <i class="far fa-redo-alt fa-lg" title="Reset Patient"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <app-rx-patient-card [RxPatientInfo]="eRxPatient"></app-rx-patient-card>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="eRxPatient?.patientid">
                <div class="col-md-12">
                    <app-rx-history [PatientId]="eRxPatient?.patientid" [IsFromPull]="true" [ShowDateRange]="true" [MultiCheck]="true"
                        (emitRxsForPull)="getRxInfo($event)" (CloseRxsForPull)="closeModal2()"   [TransferOutRxs]="isInputFocused ? transferRxInfo : []" [ActiveScreen]="'PatHis'"></app-rx-history>
                </div>
            </div>
        </span>
    </app-custom-modal>
</ng-template>